import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

// Custom style for the react-colorful colorpicker components
// Requires absolute positioning for hue / alpha sliders
export const ColorPickerCustomStyle = styled(Box)`
  .chakra-popover__popper {
    z-index: var(--vg-zIndices-popOver);
  }

  input {
    border: 1px solid var(--vg-colors-outline-gray);
    border-radius: var(--vg-radii-base);
    width: 100%;
    height: var(--vg-sizes-7);
    font-size: var(--vg-fontSizes-xs);
    text-transform: uppercase;
    text-align: center;
  }
`;

export const SideMenuColorPickerStyle = styled(Box)`
  input {
    border: 1px solid var(--vg-colors-outline-gray);
    border-radius: var(--vg-radii-base);
    width: 100%;
    height: var(--vg-sizes-7);
    font-size: var(--vg-fontSizes-sm);
    text-transform: uppercase;
    text-align: center;
  }
`;

export const StepColorPickerStyle = styled(ColorPickerCustomStyle)`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  width: 0;
  height: 2rem;
  overflow: hidden;
  border-top: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: var(--vg-colors-blackAlpha-500);

  &:first-of-type {
    border-left: 1px;
    border-left-style: inset;
    border-top-left-radius: var(--vg-radii-md);
    border-bottom-left-radius: var(--vg-radii-md);
    border-color: var(--vg-colors-blackAlpha-500);
  }

  &:last-of-type {
    border-right: 1px;
    border-right-style: inset;
    border-top-right-radius: var(--vg-radii-md);
    border-bottom-right-radius: var(--vg-radii-md);
    border-color: var(--vg-colors-blackAlpha-500);
  }
`;
